/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { observer } from "mobx-react-lite"

import { SessionViewModel } from "../../features/session/session-view-model"
import { readableUserRoles, toUserRoles } from "../../features/user/user-types"
import { valueOrDash } from "../../utils/value-or-dash"
import { useViewModel } from "../app/app-hooks"
import { Card, CardContent } from "../primitives/card"

/**
 * The signed-in user's name, username and roles.
 */
export const AccountDetails = observer(() => {
    const sessionVM = useViewModel(SessionViewModel)
    const user = sessionVM.currentUser

    return (
        <Card className="text-base">
            <CardContent>
                <dl className="m-0 grid grid-cols-[max-content_minmax(0,1fr)] gap-x-4 gap-y-2">
                    <dt className="font-normal">Name:</dt>
                    <dd className="m-0 font-semibold">{valueOrDash(user?.name)}</dd>

                    <dt className="font-normal">Username:</dt>
                    <dd className="m-0 truncate font-semibold">{valueOrDash(user?.username)}</dd>

                    <dt className="font-normal">Roles:</dt>
                    <dd className="m-0 font-semibold">
                        {valueOrDash(readableUserRoles(toUserRoles(user?.roles ?? [])).join(", "))}
                    </dd>
                </dl>
            </CardContent>
        </Card>
    )
})
